export default {
  width: 17,
  height: 19,
  stroke: true,
  svg: `
  <path fill="none" d="M16 16.3269C16 17.1283 15.1045 17.6041 14.4403 17.1556L10.179 14.2778C9.16449 13.5927 7.83551 13.5927 6.82103 14.2778L2.55966 17.1556C1.89552 17.6041 1 17.1283 1 16.3269V2.2961C1 1.94822 1.13655 1.61715 1.37555 1.37504C1.61411 1.13338 1.93492 1 2.26667 1H14.7333C15.0651 1 15.3859 1.13338 15.6245 1.37504C15.8635 1.61715 16 1.94822 16 2.2961V16.3269Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  `
}
